import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Link } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import {
  urlResolverGetDirectContactPage,
  urlResolverGetPharmaceuticalContactPage,
} from '../../url-handling'
import { useDirectContactCsHotlinePushFullStoryTracking } from '../hooks/useDirectContactCsHotlinePushFullStoryTracking'
import { useDirectContactFormTelephoneTranslations } from '../hooks/useDirectContactFormTelephoneTranslations'

export const DirectContactTelephoneUnavailable: FC<{
  isPharmaModal: boolean
}> = ({ isPharmaModal }) => {
  const globalConfig = useGlobalConfigContext()
  const { tenant } = globalConfig
  const contactFormHref = isPharmaModal
    ? urlResolverGetPharmaceuticalContactPage(globalConfig)
    : urlResolverGetDirectContactPage(globalConfig)
  const {
    getFooterDisclaimerText,
    getPhoneNumber,
    getTimeframe,
    getWeekdaysOrEntireWeekLabel,
    shouldRenderSaturdaysLine,
  } = useDirectContactFormTelephoneTranslations(isPharmaModal, tenant)

  useDirectContactCsHotlinePushFullStoryTracking()

  const contactFormButtonValue = (chunks: ReactNode[]): ReactNode => {
    return (
      <Link color="inherit" href={contactFormHref}>
        {chunks}
      </Link>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-m">
        <FormattedMessage
          id="contact.directContactSection.customerSupport.phoneUnavailable.label"
          values={{ contactFormButton: contactFormButtonValue }}
        />
      </p>
      <div className="mb-6 flex w-full flex-col gap-2 rounded-m bg-light-secondary-medium p-4 text-m">
        <p className="text-left font-medium text-dark-secondary">
          <FormattedMessage id="contact.directContactSection.customerSupportDialog.customerSupportUnavailable.title" />
        </p>
        <div className="flex justify-between">
          <p>{getWeekdaysOrEntireWeekLabel()}</p>
          <p className="font-medium">{getTimeframe()}</p>
        </div>
        {shouldRenderSaturdaysLine() ? (
          <div className="flex justify-between">
            <p>
              <FormattedMessage id="contact.directContactSection.customerSupportDialog.saturday.label" />
            </p>
            <p className="font-medium">
              <FormattedMessage id="contact.directContactSection.customerSupportDialog.availableTimeframe.saturday" />
            </p>
          </div>
        ) : null}
      </div>
      <Button className="w-full" disabled size="large" variant="filled">
        {getPhoneNumber()}
      </Button>
      <p>{getFooterDisclaimerText()}</p>
    </div>
  )
}
